import React from "react";

const FlexibleSkeleton = ({
  count = 5,
  showAvatar = true,
  showName = true,
  showRole = true,
  showContact = true,
  showButtons = true,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-gray-100 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-[35px] p-5 shadow-sm space-y-4 mx-1 animate-pulse"
        >
          {/* Top section */}
          {(showAvatar || showName || showRole) && (
            <div className="flex items-center gap-4">
              {showAvatar && (
                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl bg-gray-300 dark:bg-slate-700"></div>
                  <div className="absolute bottom-0 right-0 w-4 h-4 rounded-full bg-gray-400 dark:bg-orange-500"></div>
                </div>
              )}

              {(showName || showRole) && (
                <div className="flex-1 space-y-2">
                  {showName && (
                    <div className="h-4 w-32 bg-gray-300 dark:bg-slate-700 rounded-md"></div>
                  )}
                  {showRole && (
                    <div className="h-3 w-20 bg-gray-200 dark:bg-orange-600 rounded-md"></div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Contact section */}
          {showContact && (
            <div className="space-y-3 py-3 border-y border-slate-50 dark:border-slate-700">
              <div className="h-3 w-24 bg-gray-200 dark:bg-slate-600 rounded-md"></div>
              <div className="h-3 w-28 bg-gray-200 dark:bg-slate-600 rounded-md"></div>
            </div>
          )}

          {/* Buttons */}
          {showButtons && (
            <div className="grid grid-cols-2 gap-3 pt-1">
              <div className="h-9 bg-gray-200 dark:bg-slate-700 rounded-2xl"></div>
              <div className="h-9 bg-gray-200 dark:bg-slate-700 rounded-2xl"></div>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default FlexibleSkeleton;